import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const stats = [
  { value: "43", label: "Conversations so far" },
  { value: "70+", label: "Hours of talking" },
  { value: "6", label: "Countries" },
];

export const TestimonialsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      data-testid="testimonials-section"
      ref={ref}
      className="py-16 md:py-20 bg-[#F5ECD7]"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-12">

        <div className="grid grid-cols-3 gap-6 md:gap-12 mb-8">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              className="text-center"
            >
              <p className="font-serif text-4xl sm:text-5xl md:text-7xl text-[#2C2C2C] mb-2">
                {s.value}
              </p>
              <p className="font-sans text-xs sm:text-sm text-[#2C2C2C]/50">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="font-serif italic text-base md:text-lg text-[#2C2C2C]/40 text-center max-w-lg mx-auto"
        >
          We don't publish testimonials. Every conversation is private — that's the whole point.
        </motion.p>

      </div>
    </section>
  );
};
